query GetInboxDashboardChecklist {
    inboxDashboardChecklist {
        items {
            key
            title
            subtitle
            isComplete
        }
        percentComplete
    }
}
